import { useHistory } from 'react-router'
import { MdVisibility } from "react-icons/md"

export const InvoicesList = () => {
    const history = useHistory()

    return (

        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-start mb-3">
                            <div>
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder="Search..."
                                />
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-centered table-nowrap mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>S no.</th>
                                        <th> Date</th>
                                        <th> Booking Ref#</th>
                                        <th>Invoice Ref#</th>
                                        <th> Invoice Amount</th>
                                        <th>Adjusted Amount</th>
                                        <th> Balance Due</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    <tr>
                                        <td 
                                        // scope="row"
                                        >01</td>
                                        <td>15 May, 2021</td>
                                        <td>#5418515</td>
                                        <td>#5655163</td>
                                        <td>AED 5689.00</td>
                                        <td>AED 5689.00</td>
                                        <td>AED 5689.00</td>
                                        <td><span className="badge rounded-pill font-size-12 pointer bg-warning">Awaiting Payment</span></td>
                                        <td>
                                            <MdVisibility
                                                className="pointer"
                                                onClick={() => history.push('invoice-detail')}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                        </td>

                                    </tr>


                                    <tr>
                                        <td 
                                        // scope="row"
                                        >02</td>
                                        <td>15 May, 2021</td>
                                        <td>#5418515</td>
                                        <td>#5655163</td>
                                        <td>AED 5689.00</td>
                                        <td>AED 5689.00</td>
                                        <td>AED 5689.00</td>
                                        <td><span className="badge rounded-pill font-size-12 pointer bg-success">Settled</span></td>
                                        <td>
                                            <MdVisibility
                                                className="pointer"
                                                onClick={() => history.push('invoice-detail')}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                        </td>

                                    </tr>

                                    <tr>
                                        <td 
                                        // scope="row"
                                        >03</td>
                                        <td>15 May, 2021</td>
                                        <td>#5418515</td>
                                        <td>#5655163</td>
                                        <td>AED 5689.00</td>
                                        <td>AED 5689.00</td>
                                        <td>AED 5689.00</td>
                                        <td><span className="badge rounded-pill font-size-12 pointer bg-warning">Awaiting Payment</span></td>
                                        <td>
                                            <MdVisibility
                                                className="pointer"
                                                onClick={() => history.push('invoice-detail')}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                        </td>


                                    </tr>


                                </tbody>
                            </table>

                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}
